export default "__VITE_ASSET__BoLHATnU__"